/**
 * @generated SignedSource<<bb9de7602e52487e27d564c372c6cebd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MilestoneRow$data = {
  readonly closed: boolean;
  readonly closedIssueCount: number;
  readonly description: string | null | undefined;
  readonly dueOn: string | null | undefined;
  readonly id: string;
  readonly openIssueCount: number;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneRowMetadata" | "MilestoneRowTitle">;
  readonly " $fragmentType": "MilestoneRow";
};
export type MilestoneRow$key = {
  readonly " $data"?: MilestoneRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneRow">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MilestoneRow",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closedIssueCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "openIssueCount",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MilestoneRowTitle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MilestoneRowMetadata"
    }
  ],
  "type": "Milestone",
  "abstractKey": null
};

(node as any).hash = "97a91a45a5a4a370433b14e54c3d857e";

export default node;
